var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#545454;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.64,0C33.92,0,0,33.92,0,75.64v104.73c0,41.72,33.92,75.64,75.64,75.64h104.73c41.72,0,75.64-33.92,75.64-75.64v-104.73C256,33.92,222.08,0,180.36,0h-104.73ZM197.82,46.55c6.4,0,11.64,5.24,11.64,11.64s-5.24,11.64-11.64,11.64-11.64-5.24-11.64-11.64,5.24-11.64,11.64-11.64ZM128,64c35.32,0,64,28.68,64,64s-28.68,64-64,64-64-28.68-64-64,28.68-64,64-64ZM128,80.29c-26.34,0-47.8,21.46-47.8,47.8s21.46,47.8,47.8,47.8,47.8-21.46,47.8-47.8-21.46-47.8-47.8-47.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.a6156f0a3facc7b89f5d2fc25702f081.svg";
export { ForwardRef as ReactComponent };